import { render, staticRenderFns } from "./soltForm.vue?vue&type=template&id=24bd243c"
import script from "./soltForm.vue?vue&type=script&lang=js"
export * from "./soltForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24bd243c')) {
      api.createRecord('24bd243c', component.options)
    } else {
      api.reload('24bd243c', component.options)
    }
    module.hot.accept("./soltForm.vue?vue&type=template&id=24bd243c", function () {
      api.rerender('24bd243c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/components/soltForm.vue"
export default component.exports